import { BoxV2 as Box, Flex, Tooltip } from 'portal-commons';
import { FunctionComponent } from 'react';
import { TableCell, TableRow } from '@material-ui/core';

import { UseCase } from '@/apis/core';

interface UseCaseRowProps {
  checked: boolean;
  option: UseCase;
  onChange: (value: string) => void;
}

const UseCaseRow: FunctionComponent<UseCaseRowProps> = ({
  checked,
  option,
  onChange,
  ...props
}) => (
  <TableRow {...props}>
    <TableCell>
      <Tooltip title={option.description}>
        <Flex
          sx={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: '7px',
            width: 'fit-content',
            maxWidth: '100%',
            cursor: 'pointer',
          }}
          onClick={() => onChange(option.id)}
        >
          <input
            style={{ accentColor: '#333E41', cursor: 'pointer' }}
            type="radio"
            name="useCase"
            readOnly
            checked={checked}
          />
          <Box sx={{ fontWeight: 400, fontSize: 'H200', color: 't.black80' }}>
            {option.displayName}
          </Box>
        </Flex>
      </Tooltip>
    </TableCell>
    <TableCell>$ {option.monthlyFee}.-</TableCell>
  </TableRow>
);

export default UseCaseRow;
